export const ButtonVariant = Object.freeze({
    GHOST: "ghost", // use with ghost
    GHOST_SUCCESS: "ghost success",
    BLACK_OUTLINED: "black-outlined", // use with warning
    BLACK_CONTAINED: "black-contained", // use with warning
    WHITE_SHADOWED: "white-shadowed", // use with none
    DANGER_OUTLINED: "danger-outlined", // use with warning
    DANGER: "danger",
    ICON_BUTTON: "icon-button",
    WARNING_OUTLINED: "warning-outlined",
    HELP: "help", // soft green, fills on hover
    NOTIFICATION: "notification", // soft orange, fills on hover
    ACCOUNT: "account", // soft slate, fills on hover
});
